import React from "react";

const PaymentTabComponent = () => {
  return <div>PaymentTabComponent</div>;
};

export default PaymentTabComponent;
